import React from 'react';
import PropTypes from 'prop-types';
import PasswordResetFormContainer from './PasswordResetFormContainer';

const propTypes = {
  location: PropTypes.object.isRequired,
};

const PasswordSetPage = ({ location }) => (
  <div className="container no-sidebar">
    <div className="row">
      <div className="col-md-6 col-md-offset-3">
        <div className="card card-block">
          <h2 className="card-title">Set Your Password</h2>
          <p className="card-text">Welcome to Datarista. Please set your password below.</p>
          <PasswordResetFormContainer securityToken={location.query.auth} />
        </div>
      </div>
    </div>
  </div>
);

PasswordSetPage.propTypes = propTypes;

export default PasswordSetPage;
